<template>
  <div class="weui-panel__hd"><slot></slot></div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-panel-title',
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?7c9b9052